import gql from 'graphql-tag';

const key = `ListRoles`;
const query = gql`
query ${key} {
  listRoles(limit: 999) {
    items{
      id
      name
      group
      precedence
    }
  }
}
`;

export const LIST_ROLES = { key, query };
